export interface IEvacuationQuantityCodeableConcept {
    coding: string;
    text: string;
}